// node_modules
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";
import { FC } from "react";
// Helpers
import { ColorHelperSingleton } from "Helpers";
// styles
import styles from "./letteredUserCircle.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type TLetteredUserCircleProps = {
    username: string,
    className?: string,
    link?: string,
    onClick?: () => void,
    backgroundColor?: string,
    icon?: IconDefinition
};

export const LetteredUserCircle: FC<TLetteredUserCircleProps> = ({username, className, link, onClick, backgroundColor, icon} : TLetteredUserCircleProps) => {

    const accountLinkBackgroundColor = ColorHelperSingleton.getPastelColorFromString(username);

    return (
        <span onClick={onClick} style={{ backgroundColor: backgroundColor ? backgroundColor : accountLinkBackgroundColor }} title={username}
            className={`${styles.letteredUserCircleContainer} ${onClick ? styles.isClickable : ""} ${className ? className : ""}`}>
            {link ?
                    <a href={link}>
                        <span>{username.charAt(0).toUpperCase()}</span>
                    </a>
                :
                    icon ?
                        <FontAwesomeIcon 
                            icon={icon} />
                    :
                        <span>{username.charAt(0).toUpperCase()}</span>
            }
        </span>
    );
};